import Body from './Body'
import Header from './Header'

export { Body, Header }
